export default __webpack_public_path__ + "static/media/drawing-woman2-focusfill.c627b83d.svg";